import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'

export default {
  namespaced: true,
  state: {
    statsDBKS: {
      pois: [],
      results: {
        counts: {
          ERROR: 0,
          NEW: 0,
          SENT: 0,
          TOTAL: 0
        },
        poiMedias: {
          ERROR: {},
          NEW: {},
          SENT: {}
        }
      }
    },
    loading: false,
    configCommerceDBKS: false
  },
  getters: {
    getStatsDBKS: (state) => state.statsDBKS,
    getLoadingDBKS: (state) => state.loading,
    getStatsSENT: (state) => state.statsDBKS.results.poiMedias.SENT,
    getStatsNEW: (state) => state.statsDBKS.results.poiMedias.NEW,
    getStatsERROR: (state) => state.statsDBKS.results.poiMedias.ERROR,
    getStatsSENTCount: (state) => state.statsDBKS.results.counts.SENT,
    getStatsNEWCount: (state) => state.statsDBKS.results.counts.NEW,
    getStatsERRORCount: (state) => state.statsDBKS.results.counts.ERROR,
    getStatsTOTALCount: (state) => state.statsDBKS.results.counts.TOTAL
  },
  mutations: {
    setLoading (state, bool) {
      state.loading = bool
    },
    setStatsDBKS (state, data) {
      state.statsDBKS = data
    }
  },
  actions: {
    loadStatsDBKS ({ commit, rootState }) {
      const sitimmoUser = rootState.app.sitimmoUser
      const codeReseauSfc = sitimmoUser.codeReseauSfc
      const commerce = sitimmoUser.idExterneSfc
      if (commerce && codeReseauSfc) {
        commit('setLoading', true)
        HTTP_HYPER_ESPACE_BACKEND.get('/status')
          .then(response => {
            commit('setStatsDBKS', response.data)
          })
          .catch((error) => {
            console.log(error)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      }
    }
  }
}
